module.exports = __webpack_public_path__ + "static/media/design-principles-and-strategy.9e6040e1.png";